<template>
  <el-container>
    <el-main>
      <canvas class="codeArea" style="z-index: 0"></canvas>
      <div class="headArea" style="z-index: 1">
        <div class="searchArea">
          <p class="webTitle">Welcome to the Mars AIGC</p>
          <div class="row1">
            <p
              v-for="index in this.searchTypeList.length"
              :key="index"
              class="searchTypeTxt"
              :style="{
                fontWeight: index - 1 == searchType ? 'bolder' : 'normal',
              }"
              @click="searchTypeClick(index - 1)"
            >
              {{ searchTypeList[index - 1] }}
            </p>
          </div>
          <div class="row2">
            <div class="triangle" :style="{ left: triangleLeft }"></div>
          </div>
          <div class="row">
            <input
              type="text"
              class="searchInput"
              :placeholder="this.searchInfo.searchTxt"
              @input="inputSearchValue"
              :value="searchValue"
              @keyup.enter="searchAction()"
            />
            <p class="searchBtnTxt" @click="searchAction()">
              {{ this.searchInfo.searchBtn }}
            </p>
          </div>
          <div class="row1">
            <p
              v-for="searchItem in this.searchBottomList"
              :key="searchItem.tagName"
              class="searchBottomTxt"
              @click="searchBottomClick(searchItem)"
              :style="{
                opacity: searchItem.tagName == searchInfo.tagName ? '1' : '0.5',
              }"
            >
              {{ searchItem.tagName }}
            </p>
          </div>
        </div>

        <div class="toolsArea">
          <div class="toolSeactionHeader">
            <p
              class="headTool"
              v-for="item in headerTagList"
              :key="item.id"
              @click="clickHeadTag(item)"
            >
              {{ item.tagName }}
            </p>
          </div>
          <div class="commonTools">
            <CommonToolItem
              v-for="item in commonToolsList"
              :key="item.id"
              :info="item"
              v-on:itemClick="toolItemClick(item)"
            />
          </div>
        </div>
        <div class="rowNewsArea">
          <HotNewsBlock
            v-for="info in hotNewsList"
            :key="info.name"
            :info="info"
            v-on:clickItem="clickHotNewsItem"
            v-on:clickMore="clickHotNewsMore"
          />
        </div>
        <div class="sectionHeader" v-if="aiGuidList.length > 0">
          <img src="../assets/首页/AI教程.png" class="sectionHeaderIcon" />
          <p class="sectionHeaderTitle">AI教程</p>
          <p class="sectionHeaderMoreBtn" @click="clickMore()">更多</p>
        </div>
        <div class="infoListArea" v-if="aiGuidList.length > 0">
          <InformationItem
            v-for="infoItem in aiGuidList"
            :key="infoItem.id"
            :item="infoItem"
            v-on:clickItem="clickArticle"
          />
        </div>
        <div class="sectionHeader">
          <div class="cateListArea">
            <p
              class="cateItem"
              v-for="item in infoCategoriesList"
              :key="item.id"
              :style="{
                color: item.id == infoCateSelectedID ? '#ffffff' : '#64696f',
                backgroundColor:
                  item.id == infoCateSelectedID ? '#4972f0' : 'unset',
              }"
              @click="clickCateTag(item.id)"
            >
              {{ item.name }}
            </p>
          </div>
          <p class="sectionHeaderMoreBtn" @click="clickCateMore()">更多</p>
        </div>

        <div class="infoListArea">
          <InformationItem
            v-for="infoItem in infoList"
            :key="infoItem.id"
            :item="infoItem"
            v-on:clickItem="clickArticle"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import CommonToolItem from "@/components/CommonToolItem.vue";
import HotNewsBlock from "@/components/HotNewsBlock.vue";
import InformationItem from "@/components/InformationItem.vue";
import {
  getTagList,
  getToolsList,
  getHotNewsList,
  getCategoriesList,
  getArticleList,
  commitArticleHits,
} from "../service/api";
// import { configWxShareData } from "../service/wxsdk";
export default {
  components: {
    CommonToolItem,
    HotNewsBlock,
    InformationItem,
  },
  data() {
    return {
      AIGuidID: "1731871528933085185", //AI教程分类ID
      aiGuidList: [], //AI教程内容
      infoList: [],
      infoCateSelectedID: 0, //资讯分类选择的ID
      infoCategoriesList: [], //资讯分类
      hotNewsList: [], //热点新闻
      commonToolsList: [], //工具列表
      headerTagList: [], //顶部工具栏
      triangleLeft: "",
      searchInfo: {
        tagName: "站内",
        searchTxt: "请输入搜索内容",
        searchBtn: "搜索",
        searchUrl: window.location.href + "morearticle?searchValue=",
      }, //当前搜索选项
      searchValue: "",
      searchTypeList: ["常规", "AI", "社区", "工具"],
      searchType: 0, //大分类选项
      searchNormal: [
        {
          tagName: "站内",
          searchTxt: "请输入搜索内容",
          searchBtn: "搜索",
          searchUrl: window.location.href + "morearticle?searchValue=",
        },
        {
          tagName: "百度",
          searchTxt: "请输入搜索内容",
          searchBtn: "百度一下",
          searchUrl: "https://www.baidu.com/s?wd=",
        },
        {
          tagName: "Google",
          searchTxt: "请输入搜索内容",
          searchBtn: "Google",
          searchUrl: "https://www.google.com/search?q=",
        },
        {
          tagName: "bing",
          searchTxt: "请输入搜索内容",
          searchBtn: "bing",
          searchUrl: "https://cn.bing.com/search?q=",
        },
      ],
      searchAI: [
        {
          tagName: "",
          searchTxt: "请输入AndiSearch搜索内容",
          searchBtn: "AndiSearch",
          searchUrl: "https://andisearch.com/?q=",
        },
      ],
      searchCom: [
        {
          tagName: "知乎",
          searchTxt: "知乎找找",
          searchBtn: "搜素",
          searchUrl: "https://www.zhihu.com/search?type=content&q=",
        },
        {
          tagName: "微博",
          searchTxt: "微博找找",
          searchBtn: "搜素",
          searchUrl: "https://s.weibo.com/weibo/",
        },
        {
          tagName: "豆瓣",
          searchTxt: "豆瓣找找",
          searchBtn: "搜素",
          searchUrl: "https://www.douban.com/search?q=",
        },
      ],
      searchTool: [
        {
          tagName: "权重查询",
          searchTxt: "请输入网址(不带https://)",
          searchBtn: "查询",
          searchUrl: "https://seo.5118.com/",
        },
        {
          tagName: "友链检测",
          searchTxt: "请输入网址(不带https://)",
          searchBtn: "查询",
          searchUrl: "https://link.chinaz.com/",
        },
        {
          tagName: "PING检测",
          searchTxt: "请输入网址(不带https://)",
          searchBtn: "查询",
          searchUrl: "https://ping.chinaz.com/",
        },
        {
          tagName: "SEO综合查询",
          searchTxt: "请输入网址(不带https://)",
          searchBtn: "查询",
          searchUrl: "https://seo.chinaz.com/",
        },
        {
          tagName: "关键词挖掘",
          searchTxt: "请输入关键词",
          searchBtn: "查询",
          searchUrl: "https://www.5118.com/seo/newrelated/",
        },
        {
          tagName: "死链检测",
          searchTxt: "请输入网址(不带https://)",
          searchBtn: "查询",
          searchUrl: "https://ntool.chinaz.com/linksTesting/list?type=1&url=",
        },
      ],
      searchBottomList: [
        {
          tagName: "站内",
          searchTxt: "请输入搜索内容",
          searchBtn: "搜索",
          searchUrl: window.location.href + "morearticle?searchValue=",
        },
        {
          tagName: "百度",
          searchTxt: "请输入搜索内容",
          searchBtn: "百度一下",
          searchUrl: "https://www.baidu.com/s?wd=",
        },
        {
          tagName: "Google",
          searchTxt: "请输入搜索内容",
          searchBtn: "Google",
          searchUrl: "https://www.google.com/search?q=",
        },
        {
          tagName: "bing",
          searchTxt: "请输入搜索内容",
          searchBtn: "bing",
          searchUrl: "https://cn.bing.com/search?q=",
        },
      ],
      searchBottomIndex: 0, //小分类选项
    };
  },
  computed: {
    // 定义计算属性 searchUrl
    searchUrl() {
      return this.searchInfo.searchUrl;
    },
  },
  created() {
    // configWxShareData();
  },
  async mounted() {
    this.runCode();
    this.getToolsListAction();
    this.getSectionHeadList();
    this.getHotNewsApi();
    this.getInfoCategoriesList();
    this.getAIListAction();
    this.getInfoListAction(""); //获取“全部”分类下文章
    this.getTriangleLeft();
    this.$parent.showTopBottomView = true;
    this.$parent.showSearch = false;
  },
  methods: {
    getTriangleLeft() {
      //获取指示三角偏移
      let buttonWidth = 90;
      let windowWidth = 1920;
      if (this.$parent.isMobile || window.innerWidth < 768) {
        buttonWidth = 60;
        windowWidth = window.innerWidth;
      }
      const triangleLeft = -1.5 * buttonWidth;
      const getVwUnit = (triangleLeft / windowWidth) * 100;
      this.triangleLeft = getVwUnit + "vw";
    },
    //点击文章
    clickArticle(clickItem) {
      const articleID = clickItem.id;
      commitArticleHits(articleID);
      if (clickItem.link && clickItem.link != "") {
        window.open(clickItem.link, "_blank");
      } else {
        this.$router.push({
          path: "/detail",
          query: { articleID: articleID },
        });
      }
    },
    //获取AI教程内容
    async getAIListAction() {
      const res = await getArticleList(this.AIGuidID, 1, 4);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.aiGuidList = res.data.result.records;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //获取分类下资讯
    async getInfoListAction(cateId) {
      console.log("getInfoListAction");
      const res = await getArticleList(cateId, 1, 8);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.infoList = res.data.result.records;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //点击资讯分类
    async clickCateTag(infoCateSelectedID) {
      this.infoCateSelectedID = infoCateSelectedID;
      this.getInfoListAction(this.infoCateSelectedID);
      console.log("this.infoList=", this.infoList);
    },
    //选择分栏后点击更多
    clickCateMore() {
      this.$router.push({
        path: "/morearticle",
        query: { selectedID: this.infoCateSelectedID },
      });
    },
    //AI教程点击更多
    clickMore() {
      this.$router.push({
        path: "/morearticle",
        query: { selectedID: this.AIGuidID },
      });
    },
    //获取资讯分类
    async getInfoCategoriesList() {
      const res = await getCategoriesList(false);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        let cateArray = res.data.result.records;
        cateArray.unshift({ name: "全部", id: "" });
        this.infoCategoriesList = cateArray;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //获取新闻列表
    async getHotNewsApi() {
      const res = await getHotNewsList();
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.hotNewsList = res.data.result;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //点击顶部工具
    clickHeadTag(item) {
      console.log("tag=", item);
      this.$router.push({
        path: "/app",
        query: { tagName: item.tagName, tagID: item.id },
      });
    },
    //点击工具栏
    toolItemClick(item) {
      console.log("item=", item);
      const externalLink = item.url;
      window.open(externalLink, "_blank");
    },
    //获取顶部工具列表
    async getSectionHeadList() {
      const res = await getTagList(20);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.headerTagList = res.data.result;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //获取工具栏列表
    async getToolsListAction() {
      const res = await getToolsList(20);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.commonToolsList = res.data.result;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    clickHotNewsItem(item) {
      console.log("clickHotNewsItem", item);
      const externalLink = item;
      window.open(externalLink, "_blank");
    },
    clickHotNewsMore(info) {
      this.$router.push({
        path: "/hot",
        query: { cateName: info.name, cateIcon: info.img },
      });
    },
    searchBottomClick(searchItem) {
      console.log("searchBottomClick-", searchItem);
      this.searchInfo = searchItem;
    },
    inputSearchValue(event) {
      this.searchValue = event.target.value;
    },
    //搜索
    searchAction() {
      if (this.searchValue == "") {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      } else {
        const externalLink = this.searchInfo.searchUrl + this.searchValue;
        console.log("externalLink=", externalLink);
        window.open(externalLink, "_blank");
      }
    },
    searchTypeClick(buttonIndex) {
      console.log("this.searchType=", buttonIndex);
      // 计算白色三角形的位置，考虑按钮宽度
      this.searchType = buttonIndex;
      let buttonWidth = 90;
      let windowWidth = 1920;
      if (this.$parent.isMobile || window.innerWidth < 768) {
        buttonWidth = 60;
        windowWidth = window.innerWidth;
      }
      const triangleLeft = (buttonIndex - 1.5) * buttonWidth;
      const getVwUnit = (triangleLeft / windowWidth) * 100;
      this.triangleLeft = getVwUnit + "vw";
      console.log("triangleLeft=", triangleLeft);
      console.log("window.screen.width", window.screen.width);
      console.log("this.triangleLeft", this.triangleLeft);
      let searchBottomAllList = [
        this.searchNormal,
        this.searchAI,
        this.searchCom,
        this.searchTool,
      ];
      this.searchBottomList = searchBottomAllList[buttonIndex];
      this.searchInfo = this.searchBottomList[0];
      console.log("this.searchBottomList=", this.searchBottomList);
    },

    runCode() {
      //背景数据流
      let canvas = document.querySelector("canvas");
      let ctx = canvas.getContext("2d");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight * 0.95;
      // canvas.height = 180;
      let str = "marsai10".split("");
      let arr = Array(Math.ceil(canvas.width / 10)).fill(0);
      let run = () => {
        ctx.fillStyle = "rgba(0,0,0,0.05)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "#2b39c1";
        arr.forEach((item, index) => {
          ctx.fillText(
            str[Math.floor(Math.random() * str.length)],
            index * 10,
            item + 10
          );
          arr[index] =
            item > canvas.height || item > 10000 * Math.random()
              ? 0
              : item + 10;
        });
      };
      // run()
      setInterval(run, 50);
    },
  },
};
</script>
<style lang="scss" scoped>
.codeArea {
  width: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1;
  // height: 750px;
  // padding: 0px;
}
.el-header {
  background-color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-main {
  background-color: #f3f5f7;
  // text-align: center;
  padding: 0px;
  position: relative;
}
.headArea {
  display: flex;
  position: relative;
  flex-direction: column;
  // align-items: center;
  // margin-top: -800px;
  padding: 0px 12.5%;
  z-index: 2;
}
.webTitle {
  margin-top: 60px;
  font-weight: bold;
  font-size: 60px;
  background-color: unset;
  color: #ffffff;
  margin-bottom: 0;
}
.searchInput {
  width: 100%;
  height: 100%;
  border-radius: 27px;
  border-style: none;
  font-size: 18px;
  // padding-left: 30px;
  text-indent: 1em;
}
.searchInput::placeholder {
  color: #000000;
  font-size: 18px;
  text-indent: 1em;
}
.searchBtnTxt {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  position: absolute;
  cursor: pointer;
  line-height: 18px;
  right: 20px;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 55%;
  height: 55px;
  justify-content: center;
  margin-top: 0px;
  position: relative;
}
.row1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 55%;
  height: 60px;
  justify-content: center;
  text-align: center;
}
.row2 {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 55%;
  height: 10px;
  justify-content: center;
  margin-bottom: 0px;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid white;
  display: inline-block;
  position: relative;
  transition: left 0.3s ease; /* 添加过渡效果 */
}
.searchTypeTxt {
  font-size: 18px;
  color: #ffffff;
  width: 50px;
  margin: 0px 20px;
  line-height: 55px;
  cursor: pointer;
}
.searchBottomTxt {
  font-size: 18px;
  line-height: 18px;
  margin: 0px 20px;
  color: white;
  cursor: pointer;
}
.toolsArea {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 20px 20px rgba(73, 114, 240, 0.1);
  overflow: hidden;
  margin-top: 60px;
}
.toolSeactionHeader {
  width: 100%;
  height: 68px;
  background-color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.headTool {
  color: #ffffff;
  font-size: 18px;
  margin: 40px 0px;
  line-height: 68px;
  cursor: pointer;
}
.commonTools {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px;
}
.rowNewsArea {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-top: 60px;
}
.sectionHeader {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  align-items: center;
  margin-top: 40px;
}
.sectionHeaderIcon {
  width: 42px;
  height: 32px;
  background-color: unset;
}
.sectionHeaderTitle {
  color: #000000;
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  margin: 0px;
  text-align: left;
  margin-left: 20px;
}
.sectionHeaderMoreBtn {
  text-align: right;
  color: #000000;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
  position: absolute;
  right: 20px;
}
.cateItem {
  font-size: 18px;
  font-weight: bold;
  margin: 0px 40px 0px 0px;
  padding: 4px 7px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-align: left;
}
.cateListArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 50px;
}
.infoListArea {
  // margin-top: 20px;
  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // flex-wrap: wrap;
  // align-items: center;

  margin-top: 20px;
  margin-left: -20px;
  margin-right: -20px;
  display: flex;
  flex-wrap: wrap;
  min-height: 40px;
  margin-bottom: 60px;
}
.searchArea {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .codeArea {
    width: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 1;
    // height: 750px;
    // padding: 0px;
  }
  .el-header {
    background-color: #000000;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .el-main {
    background-color: #f3f5f7;
    // text-align: center;
    padding: 0px;
    position: relative;
  }
  .headArea {
    display: flex;
    position: relative;
    flex-direction: column;
    // align-items: center;
    // margin-top: -800px;
    padding: 0px 5%;
    z-index: 2;
  }
  .webTitle {
    margin-top: 40px;
    font-weight: bold;
    font-size: 26px;
    background-color: unset;
    color: #ffffff;
    margin-bottom: 0;
  }
  .searchInput {
    width: 100%;
    height: 100%;
    border-radius: 27px;
    border-style: none;
    font-size: 14px;
    // padding-left: 30px;
    text-indent: 1em;
  }
  .searchInput::placeholder {
    color: #000000;
    font-size: 14px;
    text-indent: 1em;
  }
  .searchBtnTxt {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    position: absolute;
    cursor: pointer;
    line-height: 18px;
    right: 20px;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 40px;
    justify-content: center;
    margin-top: 0px;
    position: relative;
  }
  .row1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 80%;
    height: 60px;
    justify-content: center;
  }
  .row2 {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 55%;
    height: 10px;
    justify-content: center;
    margin-bottom: 0px;
  }
  .triangle {
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid white;
    display: inline-block;
    position: relative;
    transition: left 0.3s ease; /* 添加过渡效果 */
  }
  .searchTypeTxt {
    font-size: 18px;
    color: #ffffff;
    width: 50px;
    margin: 0px 5px;
    line-height: 55px;
    text-align: center;
    cursor: pointer;
  }
  .searchBottomTxt {
    font-size: 15px;
    line-height: 18px;
    margin: 0px 5px;
    color: white;
    cursor: pointer;
  }
  .toolsArea {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 30px;
    background-color: #ffffff;
    box-shadow: 0 20px 20px rgba(73, 114, 240, 0.1);
    overflow: hidden;
    margin-top: 20px;
  }
  .toolSeactionHeader {
    width: 100%;
    height: 100px;
    background-color: #000000;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .headTool {
    color: #ffffff;
    font-size: 14px;
    margin: 5px 10px;
    line-height: 30px;
    cursor: pointer;
  }
  .commonTools {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 5px;
    padding-bottom: 10px;
  }
  .rowNewsArea {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    margin-top: 40px;
  }
  .sectionHeader {
    display: flex;
    flex-direction: row;
    width: 100%;
    position: relative;
    align-items: center;
    // justify-content: space-between;
    margin-top: 10px;
  }
  .sectionHeaderIcon {
    width: 32px;
    height: 22px;
    background-color: unset;
  }
  .sectionHeaderTitle {
    color: #000000;
    font-size: 22px;
    font-weight: bold;
    line-height: 24px;
    margin: 0px;
    text-align: left;
    margin-left: 20px;
  }
  .sectionHeaderMoreBtn {
    text-align: right;
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    width: 10%;
  }
  .cateItem {
    font-size: 14px;
    font-weight: bold;
    margin: 0px 5px 0px 0px;
    padding: 4px 7px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: left;
    white-space: nowrap;
  }
  .cateListArea {
    height: 40px;
    display: flex;
    width: 85%;
    flex-direction: row;
    overflow-x: auto;
  }
  .infoListArea {
    // margin-top: 20px;
    // width: 100%;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;

    margin-top: 20px;
    // margin-left: -20px;
    // margin-right: -20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // flex-wrap: wrap;
    min-height: 100px;
    margin-bottom: 30px;
  }
  .searchArea {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
